import { getStateWithOnlyOneLevel } from '../../utilities/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'associateRatesToReference');
}

export const getStudyPrograms = state => getState(state).get('studyPrograms');
export const getWaiting = state => getState(state).get('waiting');
